import { Base64 } from 'js-base64'
import type {
  DescMessage,
  DescMethodUnary,
  Message,
  MessageInitShape,
  MessageShape,
} from '@bufbuild/protobuf'
import { create, toBinary } from '@bufbuild/protobuf'
import type { GenMessage } from '@bufbuild/protobuf/codegenv1'
import type { Transport } from '@connectrpc/connect'
import type { UseQueryOptions } from '@connectrpc/connect-query'
import { callUnaryMethod } from '@connectrpc/connect-query'

import type { ContentRef } from '@jotta/grpc-connect-openapi/ref'
import { ContentRefSchema } from '@jotta/grpc-connect-openapi/ref'
import type { PartialMessage } from '@jotta/types/compat'

export async function mutate<I extends DescMessage, O extends DescMessage>(
  descriptor: DescMethodUnary<I, O>,
  data: MessageInitShape<I>,
  transport: Transport,
): Promise<MessageShape<O>> {
  return callUnaryMethod(transport, descriptor, data)
}

export type ConnectQueryOptions<O extends Message> = Omit<
  UseQueryOptions<GenMessage<O>, O>,
  'transport'
>

export function contentRefLink(ref: PartialMessage<ContentRef>['ref']) {
  const encodedRef = Base64.fromUint8Array(
    toBinary(
      ContentRefSchema,
      create(ContentRefSchema, {
        ref,
      }),
    ),
    true,
  )
  return `${window.location.origin}/r/${encodedRef}`
}
